// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// import HomeLayout from './pages/main/HomeLayout';

// import Intro from './pages/intro/intro.js';
import TracingInfoPage from './pages/main/TracingInfoPage.js'
// import RecvInspection from './pages/main/RecvInspection.js';
// import RecvStaging from './pages/main/RecvStaging.js';
// import RecvStaging_v2 from './pages/main/RecvStaging_v2.js';
// import PickingListDomestic from './pages/main/PickingListDomestic.js';
// import PickingListExport from './pages/main/PickingListExport.js';
// import DeliveryConfirmed from './pages/main/DeliveryConfirmed.js';
// import WareHousing from './pages/main/WareHousing.js';
// import CheckDeliveryStatus from './pages/main/CheckDeliveryStatus.js';
// import GwgLocMoveMgt from './pages/main/GwgLocMoveMgt.js';
// import WareHouseInventory from './pages/main/WareHouseInventory.js';


function App() {

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={ <TracingInfoPage /> } />
          {/* <Route  path="/" element={ <Login /> } /> */}
          {/* <Route path="/Home" element={<HomeLayout />}> */}
            {/* <Route path="DashBoard" element={<DashBoard />} /> */}
            {/* <Route path="GwhRcpMgt" element={<GwhRcpMgt />} /> */}
            {/* <Route path="GwhIsuMgt" element={<GwhIsuMgt />} /> */}
            {/* <Route path="GwhIvnMgt" element={<GwhIvnMgt />} /> */}
          {/* </Route> */}
          {/* <Route  path="/Main" element={ <RecvInspection /> } />
          <Route  path="/RecvStaging" element={ <RecvStaging /> } />
          <Route  path="/RecvStaging_v2" element={ <RecvStaging_v2 /> } />
          <Route  path="/PickingListDomestic" element={ <PickingListDomestic /> } />
          <Route  path="/PickingListExport" element={ <PickingListExport /> } />
          <Route  path="/DeliveryConfirmed" element={ <DeliveryConfirmed /> } />
          <Route  path="/WareHousing" element={ <WareHousing /> } />
          <Route  path="/CheckDeliveryStatus" element={ <CheckDeliveryStatus /> } />
          <Route  path="/GwgLocMoveMgt" element={ <GwgLocMoveMgt /> } />
          <Route  path="/Inventory" element={ <WareHouseInventory /> } /> */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}


export default App;
